import React from 'react';

export default function SummaryHeader() {
  return (
    <div>
      <h2 className="text-2xl font-bold text-gray-900">Professional Summary</h2>
      <p className="mt-1 text-gray-600">
        Write a compelling professional summary that highlights your key achievements, skills, and career
        goals. This is often the first thing employers read, so make it count!
      </p>
    </div>
  );
}